import * as Sentry from '@sentry/vue';

export default Sentry;
